<template>
    <stats-card
    type="successDash"
    icon="nc-icon nc-delivery-fast"
    :title="snapshot.totalSentMessages.toString(10)"
    :small-title="i18nValues['delivery']"
    >
    <div class="stats aling-between" slot="footer">
        <el-tooltip placement="bottom" effect="light" popper-class="tooltipSmall">
        <div slot="content" class="p-10">
            <el-table
            :data="detail"
            class="table tableTooltip table-hover table-striped no-more-tables no-margin">
            <el-table-column prop="type" :label="i18nValues['type']" align="left"></el-table-column>
            <el-table-column prop="cant" :label="i18nValues['quantity']" align="right"></el-table-column>
            </el-table>
        </div>
        <el-button
            class="btn-tooltip text-grey"
            size="small"
            icon="nc-icon nc-bookmark-2"
        >{{i18nValues['detail']}}</el-button>
        </el-tooltip>
    </div>
    </stats-card>
</template>
<script>
import { StatsCard } from "@/components/dashboard/index";
export default {
  name: "ClientsSection",
  props: {
      snapshot: Object,
      detail: Array,
  },
  components: {
    StatsCard,
  }
}
</script>
<style scoped>
.aling-between {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.btn-tooltip {
  border: 0px !important;
  background-color: white !important;
}
.btn-tooltip:hover,
.btn-tooltip:focus {
  background-color: white !important;
}
.btn-tooltip {
  font-size: 14px !important;
  padding: 0px 0px;
}
.text-grey {
  color: #a49e93 !important;
}
.p-10 {
  padding: 10px;
}
</style>